import type { TagValue } from './types'

/**
 * タグ文字列をTagValue形式に変換
 */
export function parseTagString(tagStr: string): TagValue {
  const match = tagStr.match(/^([a-z]+):(.+)$/)
  if (match?.[1] && match[2]) {
    return { group: match[1], name: match[2] }
  }
  return { group: null, name: tagStr }
}

/**
 * TagValueをタグ文字列に変換
 */
export function tagToString(tag: TagValue): string {
  return tag.group ? `${tag.group}:${tag.name}` : tag.name
}
